import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { ShimmerLineProps } from "../../../../Shimmer/Shimmer.types";
import { ShimmerLine } from "../../../../Shimmer/ShimmerLine/ShimmerLine";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { defaultLineShimmerWidth, lineShimmerHeight } from "../shared/styles";

export interface LineShimmerColumnProps {
    /**
     * Array of shimmer props to create line shimmers for ListItemColumns.
     * Note: Height is removed as all line shimmers have the same height.
     */
    readonly shimmerLineProps: readonly OmitStrict<ShimmerLineProps, "height">[];

    /**
     * Optional horizontal option. This can be helpful in creating a shimmer for FooterColumn.
     */
    readonly horizontal?: boolean;
}

export const LineShimmerColumn: React.FC<LineShimmerColumnProps> = ({
    shimmerLineProps,
    horizontal
}) => {

    const margin = horizontal ? "" : "0 0 4px 0";

    return (
        <Stack childrenGap="0 10px" verticalAlign="center" horizontal={horizontal}>
            {shimmerLineProps.map((prop, index) => (
                <Stack margin={(index === shimmerLineProps.length - 1) ? "" : margin} key={index}>
                    <ShimmerLine
                        height={lineShimmerHeight}
                        width={prop.width ? prop.width : defaultLineShimmerWidth}
                        shimmerColors={prop.shimmerColors}
                    />
                </Stack>
            ))}
        </Stack>
    );
};
